import React, { FC, useState } from 'react';
import { Button, Multiselect, ToastMessage } from '@cokitchen/cokitchen-components';
import LocalModal from 'components/base/local-modal';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { handleApiError } from 'utils/functions';
import { PostType } from 'models/posts.model';
import useDashboardContext from 'contexts/dashboard.context';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  post: PostType;
};

interface DuplicatePostModalFooterProps {
  onConfirm: () => void;
  loading: boolean;
  disabled: boolean;
}

const DuplicatePostModalFooter: FC<DuplicatePostModalFooterProps> = ({
  onConfirm,
  loading,
  disabled
}) => (
  <div className='flex justify-end'>
    <Button
      small
      color='primary'
      variant='block'
      className='max-w-fit'
      onClick={onConfirm}
      loading={loading}
      disabled={disabled}>
      Confirm
    </Button>
  </div>
);
const DuplicatePostModal = ({ isOpen, onClose, post }: Props) => {
  const [loading, setLoading] = useState(false);
  const [cokitchenIds, setCokitchenIds] = useState<string[]>([]);

  const { cokitchens, activeCokitchen } = useDashboardContext();

  const duplicatePost = async () => {
    setLoading(true);
    try {
      const payload = {
        title: post.title,
        heading: post.heading,
        body: post.body,
        images: Array.isArray(post.images)
          ? post.images
          : typeof post.images === 'string'
          ? JSON.parse(post.images)
          : [],
        private: Boolean(post.private),
        to_expire_date: post.to_expire_date,
        to_expire_time: post.to_expire_time,
        to_start_date: post.to_start_date,
        to_start_time: post.to_start_time,
        item_type: post.item_type || 'FOOD',
        polygon_ids: post.polygon_ids || [],
        is_fcb: Boolean(post.is_fcb),
        cokitchen_ids: cokitchenIds,
        meal_id: post.meal_id,
        brand_id: post.brand_id
      };
      await apiService.post('marketing/posts', {
        data: payload
      });
      toast(<ToastMessage type='success' message='Post duplicated successfully' />);
      onClose();
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const cokitchenOptions = cokitchens
    .filter((c) => c.id !== activeCokitchen.id)
    .map((c) => ({
      text: c.name,
      value: c.id
    }));
  return (
    <LocalModal
      isOpen={isOpen}
      onRequestClose={onClose}
      title={'Duplicate Post'}
      contentClassName='!max-w-[450px] !min-h-[400px]'
      footer={
        <DuplicatePostModalFooter
          onConfirm={duplicatePost}
          loading={loading}
          disabled={cokitchenIds.length < 1}
        />
      }>
      <div className=''>
        <label className='font-medium'>Select Cokitchen(s)</label>
        <Multiselect
          placeholder='Select Cokitchen(s)'
          values={cokitchenIds}
          options={cokitchenOptions}
          onChange={(cokitchenIds) => setCokitchenIds(cokitchenIds)}
          hasSearch
          filterResults
        />
      </div>
    </LocalModal>
  );
};

export default DuplicatePostModal;
